import { DsNotifier } from "../helpers";
import i18n from "../i18n";
import { useDsNetworkStore, useDsSystemNotifierStore } from "../stores";
import type { App } from "vue";

export const DsNetworkPlugin = {
  install(app: App, msg?: string) {
    // configure the app
    const t = i18n.global.t;
    const message = msg || t("ds.plugin.network.offline");

    window.addEventListener("offline", () => {
      useDsNetworkStore().setOffline();
      if (useDsSystemNotifierStore().networkNotificationId === 0) {
        const id = DsNotifier.sendInfo({
          message,
          duration: 0,
          enableClose: false,
          position: "top-0 right-0",
          overlay: true,
        });
        useDsSystemNotifierStore().setNetworkId(id);
      }
    });

    window.addEventListener("online", () => {
      useDsNetworkStore().setOnline();
      DsNotifier.delete(useDsSystemNotifierStore().networkNotificationId);
      useDsSystemNotifierStore().setNetworkId(0);
    });
  },
};
